import React, {useEffect, useState} from "react";
import { Image, Row, Col, Button, Form } from 'react-bootstrap';
import * as CryptoJS from 'crypto-js';
import { Spinner } from 'react-activity';
import CardComponent from '../Card';
import {ModalSettings} from '../Modals/ModalSettings';
import BackIcon from '../../../../Images/back-arrow.svg';
import BlockIcon from '../../../../Images/bloquear.svg';
import UnblockIcon from '../../../../Images/desbloquear.svg';
import ConfigIcon from '../../../../Images/configurar.svg';
import Backend from "../../../../Backend";
import Connection from "../../../../Calls";
import { store } from 'react-notifications-component';
import './physicalCard.css';

export const PhysicalCard = (props) => {
  const [check, setCheck] = useState(false);
  const [showModalSettings, setShowModalSettings] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false)

  const copyNumberToClipboard = React.createRef();

  const handleChange=(e)=>{
    setCheck(e.target.checked)   
  }

  useEffect(() => {
    getCardVirtualData()
  },[])

  const getCardVirtualData = () =>{
    setLoading(true)
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GetCardData2(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, props.currentCard?.id,  "P", response => {
        if(response.status.code == '0'){
          setLoading(false)
          let enc_data = response['payload']['data'].split(':');
          let iv = CryptoJS.enc.Base64.parse(enc_data[0]);
          let msg_enc = enc_data[1];
          const secret = 'A571784D81D9494D';
          let key = CryptoJS.enc.Utf8.parse(secret);
          let decryptedWA = CryptoJS.AES.decrypt(enc_data[1], key, {
            iv: iv,
          });
          let dec_data = decryptedWA.toString(CryptoJS.enc.Utf8);
          setCardNumber(JSON.parse(dec_data).card);
          setExpDate(JSON.parse(dec_data).date);
          setPin(JSON.parse(dec_data).key);
          props.getDate(JSON.parse(dec_data).date)
        } else {
          setLoading(false)
        }
      })
    })
  }

  const copyCardNumber = async (textToClipboard) => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(textToClipboard);
      store.addNotification({
        title: props.traductions.Card.enabled.physicalCard.L_card_copied_title,
        message: props.traductions.Card.enabled.physicalCard.L_card_copied_message,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }

      });
      return;
    } else {
      copyNumberToClipboard.current.select();
      store.addNotification({
        title: props.traductions.Card.enabled.physicalCard.L_card_copied_title,
        message: props.traductions.Card.enabled.physicalCard.L_card_copied_message,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }

      });
      return document.execCommand('copy', false, textToClipboard);
    }
    
  }

  return(
    <>
      <center>
        <Row style={{marginTop: '70px', width: '380px', marginBottom: '42px'}}>
          <Col xl={3} lg={3}>
            <Image className="back-navigation" src={BackIcon} onClick={() => {props.setRenderComponent("card"); props.getSlide(props.slide)}}/>
          </Col>
          <Col xl={6} lg={6} style={{textAlign: 'center'}}>
            <span>{props.traductions.Card.enabled.physicalCard.title}</span>
          </Col>
        </Row>
      </center>
      <center>
        <CardComponent url={props.currentCard?.image} variant={'digital-card'} unblocked={props.unblocked}/>
      </center>
      {
        loading ?
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'60%'}}>
          <Spinner animated color='#053164' size={90}/>
        </div>
        :
        <>
          <center>
            <Row style={{width: '325px', marginTop: '55px'}}>
              <Col xl={12} style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{textAlign: 'left'}}>
                  <span>{props.traductions.Card.enabled.physicalCard.L_card_number}</span><br/>
                  <input style={{width: '192px'}} className="clipboard-input" ref={copyNumberToClipboard} value={cardNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()}></input>
                </div>
                <div>
                  <Button onClick={() => copyCardNumber(cardNumber)} className='copy-btn'>{props.traductions.Card.enabled.physicalCard.L_copy}</Button>
                </div>
              </Col>

              <Col xl={12} style={{ marginTop: '30px', textAlign: 'initial'}}>
                <span>{props.traductions.Card.enabled.physicalCard.L_expiration_date}</span><br/>
                <span>{expDate}</span>
              </Col>

              <Col xl={12} style={{display: 'flex', justifyContent: 'space-between', marginTop: '30px'}}>
                <div style={{textAlign: 'left'}}>
                  <span>{props.traductions.Card.enabled.physicalCard.L_pin}</span><br/>
                  <span style={check ? {fontSize: '16px'} : {fontSize: '8px'}} > {check ? pin : "⬤⬤⬤"}</span>
                </div>
                <div style={{display: 'flex', alignItems: 'flex-end'}}>
                  <Form.Check
                    id={'switch-pin'}
                    as='input'
                    type="switch"
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col style={{display: 'flex', marginTop: '55px'}}>
                <Button disabled={loading} style={{width: '184px', marginRight: '10px'}} className={props.unblocked ? 'gray-btn' : 'black-btn'} onClick={props.onBlock}><Image src={props.unblocked ? BlockIcon: UnblockIcon} style={{marginRight: 6}}/> {props.unblocked ? props.traductions.Card.enabled.btn_StatusB : props.traductions.Card.enabled.btn_StatusU}</Button>
                <Button style={{width: '184px'}} className='gray-btn' onClick={()=> setShowModalSettings(true)}><Image src={ConfigIcon} style={{marginRight: 6}}/> {props.traductions.Card.enabled.physicalCard.L_config}</Button>
              </Col>
            </Row>
          </center>
        </>
      }
      <ModalSettings {...props} show={showModalSettings} onHide={() => setShowModalSettings(false)}/>
      </>
    
  )
}